export interface Faq {
  question: string;
  answer: string;
}

export const faqs: Faq[] = [
  {
    question: '问鼎.cc 是什么？',
    answer: '问鼎.cc 是专业的品牌官方平台，致力于为企业和个人提供安全、稳定、高效的品牌数字化服务。平台集成了品牌展示、域名管理、安全防护、数据分析等核心功能，帮助用户轻松构建可信赖的线上品牌形象。',
  },
  {
    question: '问鼎.cc 注册需要什么条件？',
    answer: '问鼎.cc 对个人和企业用户开放注册。个人用户需要提供有效的手机号码或电子邮箱，企业用户建议使用企业邮箱进行注册。注册过程简单快捷，只需几分钟即可完成。基础注册完全免费。',
  },
  {
    question: '问鼎.cc 平台安全吗？',
    answer: '绝对安全。问鼎.cc 采用了业界领先的多层安全防护体系，包括 SSL/TLS 加密传输、新一代 WAF 防火墙、DDoS 攻击防护、零信任安全架构以及定期安全审计。您的数据和隐私得到最高级别的保护。',
  },
  {
    question: '如何访问问鼎.cc 最新地址？',
    answer: '问鼎.cc 官方唯一入口即为品牌域名。建议您将本页面添加到浏览器收藏夹，以便随时快速访问。如遇访问问题，请检查您的网络连接或联系在线客服获取帮助。',
  },
  {
    question: '问鼎.cc 支持哪些服务？',
    answer: '问鼎.cc 提供全方位的品牌数字化服务，包括：品牌官网建设、域名注册与管理、SSL 证书服务、安全防护方案、数据分析工具、品牌展示空间、客户支持系统等。我们还提供定制化的企业级解决方案。',
  },
  {
    question: '忘记登录密码怎么办？',
    answer: '如果您忘记了问鼎.cc 的登录密码，可以点击登录页面的"忘记密码"链接，按照提示通过绑定的手机号码或电子邮箱重置密码。如有困难，请联系我们的客服团队获取人工协助。',
  },
  {
    question: '问鼎.cc 是否提供企业定制服务？',
    answer: '是的。问鼎.cc 为企业客户提供灵活的定制化服务方案，包括品牌专属页面设计、高级安全防护配置、API 接口对接、数据迁移支持等。请联系我们的商务团队获取详细方案和报价。',
  },
  {
    question: '如何联系问鼎.cc 客服？',
    answer: '您可以通过以下方式联系我们：在线客服（平台右下角聊天窗口）、客服邮箱 support@hecaoqing.com.cn、官方微信公众号（搜索"问鼎CC"）、或在工作日 9:00-18:00 拨打客服热线。我们致力于为您提供及时、专业的服务支持。',
  },
];